import instance from '@/utils/instance';

//获取积分历史
export function getMemberGetIntegral() {
	return instance({
		url: `/webL_api/consumer/member/getIntegral`,
		method: 'get'
	});
}
